/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Bills_Coming_OneInputs */



/**
* | output |
* | --- |
* | "1 more customer still to close this month" |
*
* @param {Partner_Billing_Bills_Coming_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_bills_coming_one = /** @type {((inputs?: Partner_Billing_Bills_Coming_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Bills_Coming_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 weiterer Kunde schließt diesen Monat noch ab")
	return /** @type {LocalizedString} */ ("1 more customer still to close this month")
});